module.exports = __webpack_public_path__ + "static/media/kwell.d58dcf5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kwell.png
// module id = 735
// module chunks = 0